export default function customImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) {
  if (src.startsWith("https://fn.gandpconstruction.com/storage") || src.startsWith("http://localhost:7071/storage")) {
    return `${src}?width=${width}`;
  } else {
    return `${src}?width=${width}&quality=${quality || 75}`;
  }
}